







































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
@Component({
    mixins: [validationMixin],
    props: {
        advanceFilterRequest: Object,
    },
    validations: {
        advanceFilterRequest: {
            appointmentDate: {
                startDate: {
                },
                endDate: {
                },
            },
        },
    },
})
export default class AdvanceSearchFilterModal extends Vue {
    private show = false;
    private mounted() {
        this.show = true;
    }

    private doSearch() {
        this.$emit('filter');
        this.close();
    }
    private close() {
        this.$emit('close');
    }
}
